import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, SparklesIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Empecé a decretar a la mañana y a la semana sentí que algo se movió. No sé explicarlo, pero el ambiente en casa cambió. Como si se hubiera limpiado algo.',
    author: 'M.',
    location: 'Buenos Aires'
  }, {
    text: 'Yo era de las que decía "esto no es para mí". Lo hice igual, como rutina. Y de golpe me di cuenta de que estaba durmiendo mejor, discutiendo menos y tomando decisiones con más claridad. No fue magia, fue orden.',
    author: 'L.',
    location: 'Córdoba'
  }, {
    text: 'Lo que más me pegó fue cerrar las fugas. Literal: cancelé suscripciones, ordené la cocina, y algo se destrabó. A los 10 días me llegó una oportunidad de laburo que venía pidiendo hace meses.',
    author: 'N.',
    location: 'Rosario'
  }, {
    text: 'Los decretos de emergencia me salvaron una noche que estaba al borde. Los leí, hice el protocolo y al otro día me levanté entera. Eso no tiene precio.',
    author: 'C.',
    location: 'Mendoza'
  }, {
    text: 'No es que "manifesté" de la nada. Es que ordené mi energía, mi casa y mis hábitos, y las cosas empezaron a fluir distinto. Como si el universo por fin tuviera espacio para responder.',
    author: 'V.',
    location: 'CABA'
  }];
  return <section className="py-10 md:py-20 px-4 bg-secondary-bg relative" data-id="element-352">
      <div className="max-w-3xl mx-auto" data-id="element-353">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-6 md:mb-10" data-id="element-354">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold/10 border border-gold/30 text-gold font-bold text-xs md:text-sm tracking-wider mb-3" data-id="element-355">
            <SparklesIcon className="w-3.5 h-3.5" data-id="element-356" />
            EXPERIENCIAS REALES
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-text-primary" data-id="element-357">
            Algo se mueve cuando ponés orden
          </h2>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-358">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className="bg-card-bg p-4 md:p-5 rounded-xl border border-border-gold shadow-sm" data-id="element-359">
              <div className="flex items-start gap-3 md:gap-4" data-id="element-360">
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center text-gold font-bold text-xs md:text-sm shrink-0 mt-0.5" data-id="element-361">
                  {t.author}
                </div>
                <div className="min-w-0" data-id="element-362">
                  <div className="flex items-center gap-2 mb-1.5" data-id="element-363">
                    <span className="text-xs md:text-sm font-bold text-text-primary" data-id="element-364">
                      {t.author}
                    </span>
                    <span className="text-[10px] md:text-xs text-text-muted" data-id="element-365">
                      · {t.location}
                    </span>
                    <div className="flex ml-auto" data-id="element-366">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 text-gold fill-gold" data-id="element-367" />)}
                    </div>
                  </div>
                  <p className="text-text-primary font-body-serif text-sm md:text-base italic leading-relaxed" data-id="element-368">
                    "{t.text}"
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}